import { TreeNode } from './types';

export function mergeTreesWithUniqueIds(trees: TreeNode[]): TreeNode[] {
  const seenIds = new Set<string>();

  const dedupeNode = (node: TreeNode): TreeNode | null => {
    if (seenIds.has(node.id)) {
      return null;
    }

    seenIds.add(node.id);

    const children = node.children
      ?.map(dedupeNode)
      .filter((child): child is TreeNode => child !== null);

    return {
      ...node,
      ...(children && children.length > 0 ? { children } : {}),
    };
  };

  return trees
    .map(dedupeNode)
    .filter((node): node is TreeNode => node !== null);
}

export function flattenTree(nodes: TreeNode[]): TreeNode[] {
  return nodes.flatMap(node => [
    node,
    ...(node.children ? flattenTree(node.children) : []),
  ]);
}

/** Finds a node label by id anywhere in the tree. */
export function findTreeNodeLabel(
  nodes: TreeNode[],
  id: string,
): string | undefined {
  return flattenTree(nodes).find(node => node.id === id)?.label;
}

/** Builds a comma-separated label list for selected node ids. */
export function getLocationDisplayValue(
  nodes: TreeNode[],
  selectedIds: string[],
  emptyPlaceholder: string,
): string {
  if (selectedIds.length === 0) {
    return emptyPlaceholder;
  }

  return selectedIds
    .map(id => findTreeNodeLabel(nodes, id))
    .filter(Boolean)
    .join(', ');
}
